module.exports = __webpack_public_path__ + "img/9.656c2510.jpg";